import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MenuSelector from '../MenuSelector';
import SecondaryButton from '../SecondaryButton';
import { globalStyles } from '../style/gstheme';
import UserAvatar from '../users/UserAvatar';
import Feedback from './Feedback';

const styles = theme => {
  return Object.assign({
    userInfo: {
      backgroundColor: 'transparent',
      position: 'absolute',
      right: 10,
      width: 400,
      top: 0,
      boxShadow: 'none',
      zIndex: 11
    },
    narrowUserInfo: {
      backgroundColor: 'transparent',
      position: 'absolute',
      right: 0,
      width: 300,
      top: 0,
      padding: '0px 20px 20px 20px',
      boxShadow: 'none',
      zIndex: 11
    },
    title: {
      textAlign: 'right'
    },
    userCardHeader: {
      fontWeight: 500,
      flexDirection: 'row-reverse',
      padding: '10px 0px 14px 0px',
      color: 'white',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    userCardActions: {
      textAlign: 'center'
    },
    userCardContent: {
      padding: '6px 6px 0px 6px'
    },
    userCardText: {
      fontSize: '12px',
      color: theme.palette.primary.main
    },
    userCardBody: {
      borderRadius: '4px',
      marginTop: '-4px',
      marginRight: '20px',
      backgroundColor: 'white',
      padding: '12px 12px 12px 12px',
      boxShadow: '0px 3px 3px #00000080'
    }
  }, globalStyles);
};

class UserInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      feedback: "",
      expanded: false
    };
  }

  handleToggle = () => {
    this.setState((prevState) => {
      return { expanded: !prevState.expanded };
    });
  };

  handleTimeChange = (time) => this.props.logOutDelay(time);

  reset = () => this.setState({ expanded: false });

  render() {

    const { classes, logOut, user, width, currentDelay } = this.props;
    const { expanded } = this.state;
    const givenName = user.givenName || "";
    const familyName = user.familyName || "";
    const username = user.username;

    return (
      <Card id="user-info" data-test="user-info" className={width === "xs" ? classes.narrowUserInfo : classes.userInfo}
        style={expanded ? { padding: '0px 0px 20px 20px' } : {}}>
        <CardHeader
          titleTypographyProps={{
            "data-test": 'user-combined-name',
            align: 'right',
            style: {
              marginRight: '15px',
              letterSpacing: '1px'
            }
          }}
          onClick={this.handleToggle}
          className={classes.userCardHeader}
          data-test="logged-in-user"
          avatar={<UserAvatar username={username} givenName={givenName} familyName={familyName} />}
          title={width !== "xs" ?
            givenName && familyName ?
              givenName.toUpperCase() + " " + familyName.toUpperCase()
              :
              username
            :
            ""}
        />
        {expanded &&
          <div className={classes.userCardBody}>
            <div data-test="login-block" onClick={this.handleToggle} style={{
              position: 'fixed',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }}>
            </div>
            <Feedback />
            <Divider style={{ marginTop: 20, marginBottom: 10 }} />
            <CardActions className={classes.userCardActions} style={{ justifyContent: 'center' }}>
              <div style={{ marginTop: 18 }}>
                <SecondaryButton dataTest="logout" size="wide" onClick={() => logOut()}>Log out</SecondaryButton>
              </div>
              <div style={{ width: 150, paddingLeft: 30 }}>
                <MenuSelector
                  dataTest="time-selector"
                  label="Log Out Delay"
                  selected={currentDelay.toString()}
                  handleChange={this.handleTimeChange}
                  hintWord="time period"
                  options={[
                    {
                      "value": "15",
                      "label": "15 mins"
                    },
                    {
                      "value": "30",
                      "label": "30 mins"
                    },
                    {
                      "value": "60",
                      "label": "60 mins"
                    }
                  ]} />
              </div>
            </CardActions>
          </div>
        }
      </Card>
    );
  }
}

UserInfo.propTypes = {
  user: PropTypes.object.isRequired,
  logOut: PropTypes.func.isRequired,
  logOutDelay: PropTypes.func.isRequired,
  currentDelay: PropTypes.number.isRequired,
  width: PropTypes.string,
  classes: PropTypes.object
};

export default withWidth()(withStyles(styles)(UserInfo));